import SlickSlider, { Settings } from 'react-slick';
import * as React from 'react';
import './Slider.css';

interface ISliderProps {
  settings: Settings;
}

export const Slider: React.FC<React.PropsWithChildren<ISliderProps>> = ({ children, settings }) => {
  return <SlickSlider {...settings}>{children}</SlickSlider>;
};
